module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_4_2-bae6f6e94a2811eb359cc5639a53a512.webp";